import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import {
  VehicleControlEditResolver,
  VehicleControlListByVehicleResolver
} from './services/vehicle-control.resolver.service';
import { VehicleControlListComponent } from './components/vehicle-control-list.component';
import { VehicleControlService } from './services/vehicle-control.services';
import { VehicleControlFormComponent } from './components/vehicle-control-form.component';
import { VehicleControlCompleteComponent } from './components/vehicle-control-complete.component';
import { AppSharedModule } from './../shared/appShared.module';
import { KubaExportModule } from './../shared/kuba-exports/kuba-export.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ exports: [
        VehicleControlListComponent,
        VehicleControlFormComponent,
        VehicleControlCompleteComponent
  ],
    declarations: [
    VehicleControlListComponent,
    VehicleControlFormComponent,
    VehicleControlCompleteComponent
  ], imports: [BrowserModule,
        TranslatePipe, TranslateDirective,
        AppSharedModule,
        RouterModule,
        KubaExportModule
  ],
  providers: [
    VehicleControlService,
    VehicleControlEditResolver,
    VehicleControlListByVehicleResolver,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class VehicleControlModule {}
